export const isPhoneCallPushEnabled = (
  canCallCandidatePolicy: boolean,
  phoneCallPushFeature: boolean
) => canCallCandidatePolicy && phoneCallPushFeature
